module.exports = require("window-or-global");


//////////////////
// WEBPACK FOOTER
// external "window-or-global"
// module id = 177
// module chunks = 0